import React from 'react';
import Select from 'react-select';
import { changeSelectedMarket } from '../../../../../store/actions/markets';
import { useDispatch, useSelector } from 'react-redux';
import styles from './MainMarkets.module.css';

const MainMarkets = () => {
    const dispatch = useDispatch();

    const locale = useSelector(state => state.settings.locale);
    const mainMarkets = useSelector(state => state.mainMarkets.data) || [];
    const marketColumns = useSelector(state => state.mainMarkets.columns);

    const onMarketChange = (market, column) => {
        dispatch(changeSelectedMarket(market.value, column));
    };

    const getColumns = () => {
        if (mainMarkets.length >= marketColumns.length) return marketColumns;

        return mainMarkets.map((market, index) => index);
    };

    const columns = getColumns() || [];

    return mainMarkets && mainMarkets.length > 0 ? (
        <div className={'flex flex-column'}>
            <div className={'flex justify-end'}>
                {columns.map(column => {
                    const foundMarket = mainMarkets.find(
                        market => market.isSelected && market.selectedIndex === column
                    );

                    const boxes = Number(foundMarket?.outcomes?.length + foundMarket?.specifiers?.length) || 0;

                    return (
                        <div
                            key={column}
                            style={{
                                width: boxes > 3 ? '300px' : '225px',
                                minWidth: boxes > 3 ? '300px' : '225px',
                                padding: '0 10px 10px',
                            }}
                            align='left'
                        >
                            <Select
                                className='common-select common-select--events'
                                classNamePrefix='common'
                                menuPlacement={'auto'}
                                value={foundMarket}
                                onChange={value => onMarketChange(value, column)}
                                options={mainMarkets
                                    .filter(market => !market.isSelected || market.selectedIndex === column)
                                    .map(market => ({
                                        value: market.id,
                                        label: market.label,
                                    }))}
                            />
                        </div>
                    );
                })}
                <div className={styles.emptyColumn} />
            </div>
            <div className={'flex justify-end'}>
                {columns.map(column => {
                    const foundMarket = mainMarkets.find(
                        market => market.isSelected && market.selectedIndex === column
                    );

                    const boxes = Number(foundMarket?.outcomes?.length + foundMarket?.specifiers?.length) || 0;

                    return (
                        <div
                            key={column}
                            style={{
                                width: boxes > 3 ? '300px' : '225px',
                                minWidth: boxes > 3 ? '300px' : '225px',
                                padding: '0 10px',
                            }}
                        >
                            <table className={styles.marketOptions}>
                                <thead>
                                    <tr>
                                        {mainMarkets.map(market => {
                                            if (market.isSelected && market.selectedIndex === column) {
                                                if (market.specifiers.length > 0) {
                                                    return (
                                                        <React.Fragment key={market.specifiers[0].name}>
                                                            <th>{market.specifiers[0].name}</th>
                                                            {market.outcomes.map(outcome => (
                                                                <th key={outcome.id}>{outcome.label}</th>
                                                            ))}
                                                        </React.Fragment>
                                                    );
                                                }
                                                return market.outcomes.map(outcome => (
                                                    <th key={outcome.id}>{outcome.label}</th>
                                                ));
                                            }
                                            return null;
                                        })}
                                    </tr>
                                </thead>
                            </table>
                        </div>
                    );
                })}
                <div className={styles.emptyColumn} />
            </div>
        </div>
    ) : null;
};

export default MainMarkets;
